import request from "@/utils/request";

export default function changeIsOpenLongpress(params) {
    return request({
        url: `/news/changeIsOpenLongpress`,
        method: 'get',
        params: params,
    })
}
